<template>
  <div>
    <van-nav-bar title="首页" class="bg-gradual-blue" />
    <div>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in advList "><van-image :src="item.advertUrl" /></van-swipe-item>
      </van-swipe>
    </div>

    <section style="padding: .2rem">
      <div style="height: 30px;line-height: 30px;">通知公告</div>
      <div style="border-radius: 15px;">
        <van-cell v-for="item in noticeList"  card :title="item.title" is-link @click="gotoDetail(item.id)"></van-cell>
      </div>
    </section>

    <Footer ref="h_bottom" page="index"></Footer>
    
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import { Swipe, SwipeItem } from 'vant';
import { Dialog } from 'vant';
import { loadData , checkLogin , initConfig } from '@/utils/common'

export default {
  data() {
    return {
      advList:[{}],
      noticeList:[]
    };
  },
  created() {
    //let index = this.active + 1;
    //this.list = this[`list${index}`]; // this.list1
    this.initData();
    this.initData2();
  },
  mounted() {
    this.$nextTick(() => {
      this.initP();
    });
  },
  components: {
    Footer,Swipe,SwipeItem
  },
  methods: {
    initP(){
      //TODO 
      //sessionStorage.setItem('login_userid','365');
      //sessionStorage.setItem('login_token','201');
      //sessionStorage.setItem('login_usercard','201');

      checkLogin();
      let bh = this.$refs.h_bottom.$el.offsetHeight;
      this.$store.commit("updateBottomH", bh);
	  //加载参数
	  initConfig();
    },
    initData(){
      loadData('/appIndex/queryAdvert',{}).then(response => {
        if(response && response.code == 0){
          this.advList = response.data;
        }
      }).catch(() => {
        //this.listLoading = false
      })
    },
    initData2(){
      loadData('/appIndex/queryNotice',{}).then(response => {
        if(response && response.code == 0){
          this.noticeList = response.data;
        }
      }).catch(() => {
        //this.listLoading = false
      })
    },
    gotoDetail(id){
      this.$router.push({ name: 'notice', params: { id: id }})
    }
  }
};

/* --gradualBlue: linear-gradient(45deg, #0081ff, #1cbbb4); background-image: var(--gradualBlue); color: var(--white); */
</script>

<style>
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    height: 200px;
    text-align: center;
  }
</style>
